import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css, cx } from '@bd/bdui-styles/emotion';
import { CompareButton } from '@bd/bdui-compare';
import { colors } from '../styles';

const styles = css`
  height: 40px;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 13px;
  letter-spacing: 2px;
  text-align: center;
  display: flex;
  align-items: center;
  cursor: pointer;
  &:focus {
    outline: none;
  }
  .CompareButton_indicator {
    display: inline-block;
    border: 1px solid black;
    width: 11px;
    height: 11px;
    margin-right: 10px;
  }

  .CompareButton_indicator-active {
    background-color: ${colors.brand3};
  }
`;

function WrappedCompareButton({ builder, ...props }) {
  if (!get(builder, 'products.BDWebsiteCompare.isPurchased')) {
    return null;
  }

  return (
    <CompareButton
      {...props}
      className={cx(styles, props.className)}
    />
  );
}

WrappedCompareButton.propTypes = {
  builder: PropTypes.object.isRequired,
  className: PropTypes.string,
};

WrappedCompareButton.defaultProps = {
  className: undefined,
};

export default withData({ builder: true })(WrappedCompareButton);



// WEBPACK FOOTER //
// ./src/components/CompareButton.js